import React from 'react'
import PropTypes from 'prop-types'
// import Sticky from 'react-stickynode';
import styled from 'styled-components'
// import Color from 'layout/colors'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { CloseIcon } from 'components/static/icons'
import { PROMPTS } from 'state/prompt/reducer'
import FullScreenModal from 'components/static/FullScreenModal'
import {Button } from 'components/buttons/logout-button'
import ToggleGif from './toggle.gif'
const LoginHeader = styled.div`
  text-align: center;
`;
const StyledLink = styled.div`
  text-decoration: none;
`

const Dismiss = styled.div`
  width: 18px;
  height: 28px;
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
`;

const Container = styled.div`
  padding: 10px;
  align-items: center;
`;

const Message = styled.p`
  display: block;
`;

const Nope = styled.h3`
  font-size: 14px;
  color: Color('purple');
  text-decoration: underline;
  text-align: center;
  margin-top: 10px;
  cursor: pointer;
`
const Gif = styled.img`
  width: 150px;
  height: 60px;
  object-fit: contain;
`
const GifContainer = styled.div`
  display: flex;
  justify-content: center;
`

class Prompts extends React.Component {
  dismissBanner = () => {
    const { store } = this.context;
    store.dispatch({
      type: "DISMISS_PROMPT"
    });
  }

  render() {

    const LoginPrompt =
      <FullScreenModal onToggleVisibility={this.dismissBanner}>
        <Dismiss onClick={this.dismissBanner}>
          <CloseIcon color="#333"/>
        </Dismiss>
        <Container>
          <LoginHeader>
            <h2>Sign up to save your vote</h2>
          </LoginHeader>
          <GifContainer>
            <Gif src={ToggleGif} alt="toggle"/>
          </GifContainer>
          <Message>
            Sign up or log in to save your how you plan to vote, your notes, and your comments. Then, help your friends by sharing your recommendations using a unique link. <StyledLink to="/my-digital-ballot/" onClick={this.dismissBanner}>See what a Digital Ballot looks like,</StyledLink> or jump right in:
          </Message>
          <StyledLink to="/user/register/"><Button onClick={this.dismissBanner}>Sign up / Login</Button></StyledLink>
          <Nope onClick={this.dismissBanner}>No, thanks</Nope>
        </Container>
      </FullScreenModal>

    const { prompt } = this.props;
    if (prompt.status === PROMPTS.LOGIN) {
      return LoginPrompt;
    }
    return null;
  }
}

Prompts.contextTypes = {
  store: PropTypes.object
};

function mapStateToProps(state) {
  const { prompt } = state;
  return { prompt };
}

export default connect(mapStateToProps, {})(withRouter(Prompts));



// WEBPACK FOOTER //
// ./src/components/static/Prompts.js